import { DOM } from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM';
import { Plyr } from './Plyr';

export class MyAccountTutorials {
    constructor() {
        this.#addEvents();
    }

    async #addEvents() {
        const tutorialsWrapper = DOM.el('.my-account-tutorial-wrapper');

        if (tutorialsWrapper) {
            const videoWrapper = DOM.el('.video-container', tutorialsWrapper)
            const videoElement = DOM.el('#my-account-tutorial-video', videoWrapper);
            const video = videoWrapper.dataset.videoUrl;
            if (videoElement) {
                await Plyr.renderPlayer(videoElement, {
                    controls: ['play-large', 'progress', 'volume'],
                    hideControls: true,
                    fullscreen: true
                });
            }
        }
    }
}
